import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './MasikDurga.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import axios from 'axios';


import city from '../../../city.json'

const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};

const MasikDurga = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('New Delhi, India');
  const [timeFormat, setTimeFormat] = useState('12');

  const [DurgaList, setDurgaList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedDurga, setSelectedDurga] = useState(null);


  
  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };


  const durgashtamiTooltips = {
  "Masik Durgashtami": "Masik Durgashtami is a monthly observance dedicated to Goddess Durga, celebrated on the Shukla Ashtami (eighth lunar day) each month. Devotees worship the fierce form of Durga to seek her protection, strength, and blessings for health and prosperity."
};

useEffect(() => {
  const fetchDurgaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/durgashtami?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.durgashtamiDates) {
        setDurgaList(response.data.durgashtamiDates);
      } else {
        setDurgaList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch durga data:", error);
      setDurgaList([]);
    }
  };

  fetchDurgaData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName);   // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="MasikDurga-container">
      <InnerNav />
      <div className="MasikDurga-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Durga Ashtami Dates</h2>
              <div className="current-ekadashi">
                <img src="https://akm-img-a-in.tosshub.com/indiatoday/images/story/202303/goddess-g017e06cac_1920-sixteen_nine.jpg?VersionId=mK1qsWowqvU_KDR7CKqzYFin0mu_McsS&size=690:388" alt="Moon" className="moon-preview" />
                <div>
                 
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="Durga-controls">
                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>
{!selectedDurga ? (
  <div className="durga-list">
    {DurgaList.length === 0 && (
      <p>No durga puja data available for selected year/location.</p>
    )}

    {DurgaList.map((item, idx) => (
      <div
        className="durga-item clickable"
        key={idx}
        onClick={() => setSelectedDurga(item)}
      >
        <img
          src="https://img.favpng.com/14/10/19/durga-ashtami-iJsrzMXT.jpg"
          alt={item.title}
        />

        <div className="durga-details">
          <p className="durga-date">{item.date}</p>
          <div className="durga-name">{item.title}</div>
          <p className="durga-phase">{item.muhurta}</p>
          <p className="durga-tithi">{item.tithiName}</p>
          <p className="durga-tithi">{item.duration}</p>
        </div>

        <div className="durga-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="durga-detail-view">
    <button className="back-btn" onClick={() => setSelectedDurga(null)}>
      ← Back
    </button>

    <h2 className="detail-title">{selectedDurga.title}</h2>

    <img
      className="detail-image"
      src="https://img.favpng.com/14/10/19/durga-ashtami-iJsrzMXT.jpg"
      alt={selectedDurga.title}
    />

    {/* EVENT DETAILS */}
    <div className="detail-section">
      <h3>📅 Event Details</h3>
      <p><strong>Date:</strong> {selectedDurga.date}</p>
      <p><strong>Muhurta:</strong> {selectedDurga.muhurta}</p>
      <p><strong>Tithi:</strong> {selectedDurga.tithiName}</p>
      <p><strong>Duration:</strong> {selectedDurga.duration}</p>
    </div>

    {/* TIMING DETAILS */}
    <div className="detail-section">
      <h3>⏰ Timing Information</h3>
      <p><strong>Tithi Start:</strong> {formatTime(selectedDurga.tithiStart, timeFormat)}</p>
      <p><strong>Tithi End:</strong> {formatTime(selectedDurga.tithiEnd, timeFormat)}</p>
    </div>

    {/* LUNAR DETAILS */}
    <div className="detail-section">
      <h3>🌙 Lunar Details</h3>
      <p>{selectedDurga.lunarDetail}</p>
    </div>

    {/* SIGNIFICANCE */}
    <div className="detail-section">
      <h3>🕉️ Significance</h3>
      <p>
        {durgashtamiTooltips[selectedDurga.title] ||
          "Masik Durgashtami is observed to seek Goddess Durga’s blessings for strength, protection, courage, and victory over obstacles."}
      </p>
    </div>
  </div>
)
}

        </div>
        {/* Ekadashi Calendar JSX ends here */}

         <section className="masikdurgashtami-wrapper">
      <h1 className="masikdurgashtami-title">Masik Durgashtami</h1>
      <div className="masikdurgashtami-texts">
        <p>
          Durgashtami fasting is observed every month during Ashtami Tithi of Shukla Paksha. On this day devotees of Goddess Durga worship Her and observe day long fast.
        </p>

        <p>
          The most significant Durgashtami, which is known as Mahashtami, falls in month of Ashwin during nine days Shardiya Navratri festivities.
        </p>

        <p>
          Durgashtami is also spelled as Durga Ashtami and Masik Durgashtami is also known as Maas Durgashtami or Monthly Durgashtami.
        </p>
      </div>
    </section>
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default MasikDurga;
